import { SET_CLID_SOURCE_TYPE } from 'actions';

export const setClidSourceType = (clid: string) => {
  return { clid, type: SET_CLID_SOURCE_TYPE };
};
